import React, { useState } from 'react';
import { Calendar, Mail, MapPin, Phone, X, ChevronLeft, ChevronRight, Menu } from 'lucide-react';

function App() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [selectedImageIndex, setSelectedImageIndex] = useState<number | null>(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const slides = [
    'https://www.tanieredarmand.be/teniduloup2.webp',
    'https://www.tanieredarmand.be/taniereduloup.webp'
  ];

  const galleryImages = [
    {
      url: 'https://www.tanieredarmand.be/1.jpg',
    },
    {
      url: 'https://www.tanieredarmand.be/2.jpg',
    },
    {
      url: 'https://www.tanieredarmand.be/3.jpg',
    },
    {
      url: 'https://www.tanieredarmand.be/4.jpg',
    },
    {
      url: 'https://www.tanieredarmand.be/5.jpg',
    },
    {
      url: 'https://www.tanieredarmand.be/6.jpg',
    },
    {
      url: 'https://www.tanieredarmand.be/10.jpg',
    },
    {
      url: 'https://www.tanieredarmand.be/11.jpg',
    },
    {
      url: 'https://www.tanieredarmand.be/12.jpg',
    },
    {
      url: 'https://www.tanieredarmand.be/13.jpg',
    },
    {
      url: 'https://www.tanieredarmand.be/14.jpg',
    },
    {
      url: 'https://www.tanieredarmand.be/15.jpg',
    }
  ];

  React.useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const scrollToSection = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  const handlePrevImage = () => {
    if (selectedImageIndex === null) return;
    setSelectedImageIndex((prev) => 
      prev === 0 ? galleryImages.length - 1 : prev - 1
    );
  };

  const handleNextImage = () => {
    if (selectedImageIndex === null) return;
    setSelectedImageIndex((prev) => 
      prev === galleryImages.length - 1 ? 0 : prev + 1
    );
  };

  const handleKeyDown = (e: KeyboardEvent) => {
    if (selectedImageIndex === null) return;
    if (e.key === 'ArrowLeft') handlePrevImage();
    if (e.key === 'ArrowRight') handleNextImage();
    if (e.key === 'Escape') setSelectedImageIndex(null);
  };

  React.useEffect(() => {
    if (selectedImageIndex !== null) {
      window.addEventListener('keydown', handleKeyDown);
      return () => window.removeEventListener('keydown', handleKeyDown);
    }
  }, [selectedImageIndex]);


  return (
    <div className="min-h-screen bg-stone-50">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 bg-white shadow-md z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between md:justify-start items-center h-20 relative">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 rounded-md text-gray-700 hover:text-custom-green hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-custom-green"
            >
              {isMenuOpen ? (
                <X className="h-6 w-6" aria-hidden="true" />
              ) : (
                <Menu className="h-6 w-6" aria-hidden="true" />
              )}
            </button>
            <div className="absolute left-1/2 -translate-x-1/2 md:static md:left-auto md:transform-none md:flex-1 md:flex md:justify-start">
              <img
                src="https://www.tanieredarmand.be/Logotaniere.png"
                className="h-[72px] w-auto"
              />
            </div>
            {/* Desktop Menu */}
            <div className="hidden md:flex space-x-8">
              <button
                onClick={() => scrollToSection('presentation')}
                className="text-gray-700 hover:text-custom-green px-3 py-2 text-base font-semibold relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 hover:after:w-full after:bg-custom-green after:transition-all"
              >
                Présentation
              </button>
              <button
                onClick={() => scrollToSection('tarifs')}
                className="text-gray-700 hover:text-custom-green px-3 py-2 text-base font-semibold relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 hover:after:w-full after:bg-custom-green after:transition-all"
              >
                Tarifs & conditions
              </button>
              <button
                onClick={() => scrollToSection('galerie')}
                className="text-gray-700 hover:text-custom-green px-3 py-2 text-base font-semibold relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 hover:after:w-full after:bg-custom-green after:transition-all"
              >
                Galeries
              </button>
              <button
                onClick={() => scrollToSection('reservation')}
                className="text-gray-700 hover:text-custom-green px-3 py-2 text-base font-semibold relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 hover:after:w-full after:bg-custom-green after:transition-all"
              >
                Réservation
              </button>
              <button
                onClick={() => scrollToSection('acces')}
                className="text-gray-700 hover:text-custom-green px-3 py-2 text-base font-semibold relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 hover:after:w-full after:bg-custom-green after:transition-all"
              >
                Accès
              </button>
            </div>
          </div>
          {/* Mobile Menu */}
          <div 
            className={`absolute left-0 right-0 bg-white shadow-lg md:hidden ${
              isMenuOpen ? 'block' : 'hidden'
            }`}
          >
            <div className="px-2 pt-2 pb-3 space-y-1">
              <button
                onClick={() => {
                  scrollToSection('presentation');
                  setIsMenuOpen(false);
                }}
                className="block w-full text-left px-3 py-2 rounded-md text-base font-semibold text-gray-700 hover:text-custom-green hover:bg-gray-50"
              >
                Présentation
              </button>
              <button
                onClick={() => {
                  scrollToSection('tarifs');
                  setIsMenuOpen(false);
                }}
                className="block w-full text-left px-3 py-2 rounded-md text-base font-semibold text-gray-700 hover:text-custom-green hover:bg-gray-50"
              >
                Tarifs & conditions
              </button>
              <button
                onClick={() => {
                  scrollToSection('galerie');
                  setIsMenuOpen(false);
                }}
                className="block w-full text-left px-3 py-2 rounded-md text-base font-semibold text-gray-700 hover:text-custom-green hover:bg-gray-50"
              >
                Galeries
              </button>
              <button
                onClick={() => {
                  scrollToSection('reservation');
                  setIsMenuOpen(false);
                }}
                className="block w-full text-left px-3 py-2 rounded-md text-base font-semibold text-gray-700 hover:text-custom-green hover:bg-gray-50"
              >
                Réservation
              </button>
              <button
                onClick={() => {
                  scrollToSection('acces');
                  setIsMenuOpen(false);
                }}
                className="block w-full text-left px-3 py-2 rounded-md text-base font-semibold text-gray-700 hover:text-custom-green hover:bg-gray-50"
              >
                Accès
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Add padding to account for fixed navbar */}
      <div className="pt-20">
        {/* Hero Section */}
        <header className="relative h-screen">
          <div className="absolute inset-0">
            {slides.map((slide, index) => (
              <div
                key={slide}
                className={`absolute inset-0 transition-opacity duration-1000 ${
                  index === currentSlide ? 'opacity-100' : 'opacity-0'
                }`}
              >
                <img
                  src={slide}
                  alt="Tanière d'Armand"
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
            <div className="absolute inset-0 bg-black/40" />
          </div>
          <div className="relative h-full flex flex-col items-center justify-center text-white text-center px-4">
            <h1 className="text-6xl md:text-7xl font-light mb-4">La Tanière d'Armand</h1>
            <p className="text-xl md:text-2xl mb-8 font-light">
              Un refuge de charme au cœur des Ardennes
            </p>
            <button
              onClick={() => scrollToSection('presentation')}
              className="px-8 py-3 bg-custom-green/80 hover:bg-custom-green transition-colors rounded-full text-lg"
            >
              Découvrir
            </button>
          </div>
        </header>

        {/* Presentation Section */}
        <section id="presentation" className="py-20 px-4 md:px-8 max-w-7xl mx-auto">
          <h2 className="text-4xl text-center mb-16 text-custom-green">
            Le Téli du Loup
          </h2>
          <div className="grid md:grid-cols-2 gap-12 items-stretch">
            <div className="space-y-6 text-gray-700">
              <p className="text-lg leading-relaxed">
                Dans la Tanière d'Armand se loge un endroit romantique et rural.
                On vous présente le <strong>« Téli du Loup pour 2 personnes »</strong>. 
                Gite chaleureux avec <strong>Jacuzzi</strong> ainsi qu'une <strong>vue imprenable</strong> !
              </p>
              <p className="text-lg leading-relaxed">
                Découvrez notre gîte, un <strong>espace privatif de 50m2</strong>, conçu pour une déconnexion totale dans une nature incroyable. 
                Ce gîte est équipé d'un espace repas, un salon avec TV et jeux de société, une chambre avec <strong>excellente literie (draps satinés)</strong> et une salle de bain avec bain-douche et toilette. 
                La <strong>terrasse privative</strong> avec 2 transats, un petit espace repas au bord de l'eau et votre <strong>jacuzzi bien chaud</strong> vous ressourceront !
              </p>
              <p className="text-lg leading-relaxed">
                Des <strong>peignoirs, des serviettes et des produits de toilette</strong> sont à votre disposition.
                Lors de votre arrivée, une <strong>bouteille de bulles vous sera offerte</strong>.
              </p>
              <p className="text-lg leading-relaxed">
                Le gîte vous offre également un <strong>parking privé</strong>.
                Situé à <strong>14 km de Spa Francorchamps</strong> mais aussi proche de l'Abbaye de Stavelot, Plopsa Coo, les Hautes Fagnes, piste de ski de fond, aérodrome de spa, centre thermal.
              </p>
            </div>
            <div className="rounded-lg overflow-hidden shadow-xl h-full">
              <img
                src="https://www.tanieredarmand.be/Jardin.webp"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </section>

        {/* Pricing and Schedule Section */}
        <section id="tarifs" className="py-20 bg-custom-green text-white">
          <div className="px-4 md:px-8 max-w-7xl mx-auto">
            <div className="grid md:grid-cols-2 gap-12">
              <div className="space-y-4">
                <h3 className="text-2xl font-bold text-white mb-6">Tarifs et conditions</h3>
                <p className="text-lg mb-4">
                  <strong>250€ la nuit charges incluses</strong> avec un minimum de 2 nuitées. Tarif valable hors vacances scolaires, Grand-Prix F1, long weekend, Noël et Nouvel An (sur demande).
                </p>
                <p className="text-lg mb-4">
                  A partir de <strong>5 nuitées</strong>, vous aurez accès à la piscine intérieure, la salle de sport et la salle de jeux de la Tanière d'Armand. (selon horaire et disponibilité)
                </p>
                <div className="mt-6">
                  <table className="w-full text-lg">
                    <tbody>
                      <tr className="[&>*]:py-2 [&>*]:pr-4">
                        <td><strong>Caution :</strong> 250€</td>
                        <td><strong>Acompte :</strong> 30% du prix</td>
                        <td><strong>Taxe :</strong> 6€/nuit</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p className="text-sm text-white/80 italic mt-4">
                  Prix donné à titre indicatif et non contractuel
                </p>
              </div>
              <div className="space-y-4">
                <h3 className="text-2xl font-bold text-white mb-6">Arrivée et départ</h3>
                <ul className="space-y-4 text-lg">
                  <li className="flex items-start space-x-2">
                    <Calendar className="mt-1 flex-shrink-0 text-white" size={20} />
                    <span>
                      <strong>Week-end :</strong> arrivée le vendredi entre 16h et 18h, départ le dimanche entre 16h et 18h.
                    </span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <Calendar className="mt-1 flex-shrink-0 text-white" size={20} />
                    <span>
                      <strong>Mid-Week :</strong> arrivée le lundi entre 16h et 18h, départ le vendredi à 10h.
                    </span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <Calendar className="mt-1 flex-shrink-0 text-white" size={20} />
                    <span>
                      <strong>Semaine :</strong> arrivée le vendredi entre 16h et 18h, départ le vendredi à 10h.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Gallery Section */}
        <section id="galerie" className="py-20 bg-white">
          <div className="px-4 md:px-8 max-w-7xl mx-auto">
            <h2 className="text-4xl text-center mb-16 text-custom-green">
              Découvrez la Tanière en images
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
              {galleryImages.map((image, index) => (
                <div
                  key={image.url}
                  className="relative overflow-hidden rounded-lg shadow-lg aspect-[4/3] group cursor-pointer"
                  onClick={() => setSelectedImageIndex(index)}
                >
                  <img
                    src={image.url}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Image Modal */}
        {selectedImageIndex !== null && (
          <div 
            className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center"
            onClick={() => setSelectedImageIndex(null)}
          >
            <div className="relative w-full h-full flex items-center justify-center p-4">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handlePrevImage();
                }}
                className="absolute left-4 p-2 text-white hover:bg-white/10 rounded-full transition-colors"
                aria-label="Image précédente"
              >
                <ChevronLeft size={32} />
              </button>
              
              <img
                src={galleryImages[selectedImageIndex].url}
                className="max-h-[90vh] max-w-[90vw] object-contain"
                onClick={(e) => e.stopPropagation()}
              />
              
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleNextImage();
                }}
                className="absolute right-4 p-2 text-white hover:bg-white/10 rounded-full transition-colors"
                aria-label="Image suivante"
              >
                <ChevronRight size={32} />
              </button>
              
              <button
                onClick={() => setSelectedImageIndex(null)}
                className="absolute top-4 right-4 p-2 text-white hover:bg-white/10 rounded-full transition-colors"
                aria-label="Fermer"
              >
                <X size={24} />
              </button>
            </div>
          </div>
        )}

        {/* Booking Section */}
        <section id="reservation" className="py-20 px-4 md:px-8 max-w-3xl mx-auto">
          <h2 className="text-4xl text-center mb-8 text-custom-green">
            Réservez votre séjour
          </h2>
          <p className="text-center text-gray-700 mb-12">
            Prêt à vivre une expérience unique dans les Ardennes ? Contactez-nous dès
            aujourd'hui pour réserver votre séjour à la Tanière d'Armand.
          </p>
          <form
            action="https://formsubmit.co/ebd3204ea2833f843f1efb99d365ef2c"
            method="POST"
            className="space-y-6"
          >
            <input type="hidden" name="_subject" value="Nouvelle réservation - La Tanière d'Armand" />
            <input type="hidden" name="_captcha" value="false" />
            <input type="hidden" name="_template" value="table" />
            <input type="hidden" name="_next" value={window.location.href} />
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Nom et prénom
                </label>
                <input
                  type="text"
                  name="name"
                  className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-custom-green focus:border-transparent"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Adresse e-mail
                </label>
                <input
                  type="email"
                  name="email"
                  className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-custom-green focus:border-transparent"
                  required
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Téléphone
              </label>
              <input
                type="tel"
                name="phone"
                className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-custom-green focus:border-transparent"
                required
              />
            </div>
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Date d'arrivée
                </label>
                <input
                  type="date"
                  name="arrival"
                  className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-custom-green focus:border-transparent"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Date de départ
                </label>
                <input
                  type="date"
                  name="departure"
                  className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-custom-green focus:border-transparent"
                  required
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Message (optionnel)
              </label>
              <textarea
                name="message"
                rows={4}
                className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-custom-green focus:border-transparent"
              ></textarea>
            </div>
            <button
              type="submit"
              className="w-full py-3 bg-custom-green hover:bg-custom-green/90 text-white rounded-lg transition-colors"
            >
              Envoyer ma demande
            </button>
          </form>
        </section>

        {/* Access Point Section */}
        <section id="acces" className="py-12 bg-white">
          <div className="px-4 md:px-8 max-w-7xl mx-auto">
            <h2 className="text-4xl text-center mb-8 text-custom-green">
              Point d'Accès
            </h2>
            <div className="max-w-3xl mx-auto p-6">
              <div className="flex items-start space-x-4">
                <MapPin className="flex-shrink-0 text-custom-green mt-1" size={24} />
                <p className="text-lg leading-relaxed text-gray-700">
                  Bruxelles E40/A3 direction Liège/Aachen puis E42 direction Verviers, sortie 12 Bellevaux-Ligneuville, 
                  ensuite rester sur la voie de droite, puis suivre Bellevaux pour rejoindre Fourir/Refat puis arrivée à Beaumont.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Map Section */}
        <section className="w-full">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2541.5751392405396!2d5.926864776891757!3d50.41736767169818!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c07c2821c6499d%3A0x8bf49b4ca85591cf!2sBeaumont%2013%2C%204970%20Stavelot%2C%20Belgique!5e0!3m2!1sfr!2sfr!4v1710425847736!5m2!1sfr!2sfr"
            width="100%"
            height="350"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Localisation de la Tanière d'Armand"
            className="w-full"
          ></iframe>
        </section>

        {/* Footer */}
        <footer className="bg-custom-green text-white py-12">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="space-y-4">
                <h3 className="text-xl font-semibold mb-4">Contact</h3>
                <div className="flex items-center space-x-3">
                  <Phone size={20} />
                  <span>+32(0)473611202 </span>
                </div>
                <div className="flex items-center space-x-3">
                  <Mail size={20} />
                  <span>contact@tanieredarmand.be</span>
                </div>
              </div>
              <div className="space-y-4">
                <h3 className="text-xl font-semibold mb-4">Adresse</h3>
                <div className="flex items-center space-x-3">
                  <MapPin size={20} />
                  <span>13 Beaumont<br />4970 Stavelot<br />Belgique</span>
                </div>
              </div>
              <div className="space-y-4">
                <h3 className="text-xl font-semibold mb-4">Suivez-nous</h3>
                <div className="flex space-x-4">
                  <a href="#" className="hover:text-green-300 transition-colors">Facebook</a>
                </div>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-4">La Tanière d'Armand</h3>
                <p className="text-green-100">
                  Un séjour inoubliable au cœur de la nature ardennaise.
                </p>
              </div>
            </div>
            <div className="mt-12 pt-8 border-t border-custom-green/20 text-center text-green-100">
              <p>&copy; {new Date().getFullYear()} La Tanière d'Armand. Tous droits réservés.</p>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default App;